window.RestrictedPositionAPI = new (function () {
    const self = this;
    const _protected = BaseAPI.call(self);

    self.getActivePositions = function (brandId) {
        const deferred = $q.defer();
        _protected.request(`brands/${brandId}/settings/positions/active`, 'GET')
            .then(function (data) {
                if (data?.data?.data && data.status === 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };
});
